/**
 * The chat this tab was showing, restored when the tab switches back into chat mode
 * (App.js; the URL's history_id covers a reload in chat mode).
 *
 * PLEX-6783: sessionStorage alone isn't per-tab. A tab opened from another one (window.open,
 * a link that keeps its opener) starts with a copy of the opener's sessionStorage, so it adopted
 * the other tab's conversation, a running one included, and showed the "currently active" guard
 * for a chat it never opened. The saved value now names the tab that saved it, by window.name,
 * which a reload of that tab keeps and a newly opened tab doesn't have.
 */
const KEY = "chat-history-id";
const TAB_PREFIX = "plex-tab-";

const thisTab = () => {
  if (!window.name) {
    const id = window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2);
    window.name = `${TAB_PREFIX}${id}`;
  }
  return window.name;
};

export const saveTabChat = (conversationId) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ id: conversationId, tab: thisTab() }));
  } catch (_) { /* storage unavailable: nothing to restore later */ }
};

/** The chat this tab saved, or null (none, someone else's, or a pre-PLEX-6783 bare id). */
export const tabChat = () => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || "null");
    return saved && saved.tab === window.name && window.name ? saved.id : null;
  } catch (_) {
    return null;
  }
};

export const clearTabChat = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) { /* nothing to clear */ }
};
